import type { HTMLAttributes } from 'react';

import styles from './Backdrop.module.css';

export type BackdropProps = Omit<HTMLAttributes<HTMLDivElement>, 'className' | 'style'>;

/** Represents a component to dim the screen, used in combination with a modal dialog. Accepts normal HTML attributes, except className and style. */
export const Backdrop = ({ children, ...restProps }: BackdropProps) => (
  <div {...restProps} className={styles['backdrop']}>
    {children}
  </div>
);
